var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details_content_repeat"},[_c('QS-h4-title',{attrs:{"title":"车辆信息"}}),_vm._v(" "),_c('QS-common-table',{attrs:{"data":_vm.tableData,"columns":_vm.headColumn,"pagination":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }